// ===== ADMIN GRH =====
import Trombinoscope from "../app/modules/adminrh/donnesrh/trombinoscope";
import Organigramme from "../app/modules/adminrh/donnesrh/Organigramme";

import WorkflowManagement from "../app/modules/adminrh/parametres/parametresJS/WorkflowManagement";
import ParametrageAttestations from "../app/modules/adminrh/parametres/parametresJS/ParametrageAttestations";
import ParamJT from "../app/modules/adminrh/parametres/parametresJS/ParamJT";
import ParamNF from "../app/modules/adminrh/parametres/parametresJS/ParamNF";
import ParamAvances from "../app/modules/adminrh/parametres/parametresJS/ParamAvances";
import ParamMissions from "../app/modules/adminrh/parametres/parametresJS/ParamMissions";
import ParamConges from "../app/modules/adminrh/parametres/parametresJS/ParamConges";
import ParamAvantagesSociaux from "../app/modules/adminrh/parametres/parametresJS/ParamAvantagesSociaux";

import TraitementConges from "../app/modules/adminrh/Traitement/TraitementJS/TraitementConges";
import TraitementDivers from "../app/modules/adminrh/Traitement/TraitementJS/TraitementDivers";
import TraitementNotesFrais from "../app/modules/adminrh/Traitement/TraitementJS/TraitementNotesFrais";
import TraitementOrdreMission from "../app/modules/adminrh/Traitement/TraitementJS/TraitementOrdreMission";
import TraitementAvances from "../app/modules/adminrh/Traitement/TraitementJS/TraitementAvances";
import TraitementAvantagesSociaux from "../app/modules/adminrh/Traitement/TraitementJS/TraitementAvantagesSociaux";
import TraitementFeuillesTemps from "../app/modules/adminrh/Traitement/TraitementJS/TraitementFeuillesTemps";

import Offboarding from "../app/modules/adminrh/Offboarding/OffboardingJS/Offboarding";
import OffboardingEtapesSettings from "../app/modules/adminrh/Offboarding/OffboardingJS/OffboardingEtapesSettings";
import DashboardAdmin from "../app/modules/adminrh/Dashboard/DashboardJS/DashboardAdmin";

// ===== MANAGER GRH =====
import DashboardManager from "../app/modules/adminrh/Dashboard/DashboardJS/DashboardManager";
import HistoriqueDemandes from "../app/modules/adminrh/Manager/HistoriqueDemandes";
import AgendaManager from "../app/modules/adminrh/Agenda/AgendaManager";
import TraitementCongesManager from "../app/modules/adminrh/Traitement/TraitementJS/TraitementCongesManager";
import TraitementOrdreMissionManager from "../app/modules/adminrh/Traitement/TraitementJS/TraitementOrdreMissionManager";
import TraitementAvancesManager from "../app/modules/adminrh/Traitement/TraitementJS/TraitementAvancesManager";
import TraitementFeuillesTempsManager from "../app/modules/adminrh/Traitement/TraitementJS/TraitementFeuillesTempsManager";
import DemandeMissionManager from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/DemandeMissionManager";
import DemandeMissionAdmin from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/DemandeMissionAdmin";
import TraitementNotesFraisManager from "../app/modules/adminrh/Traitement/TraitementJS/TraitementNotesFraisManager";
import TraitementDiversManager from "../app/modules/adminrh/Traitement/TraitementJS/TraitementDiversManager";

// ===== COLLABORATEUR =====
import DashboardCollabRH from "../app/modules/adminrh/Dashboard/DashboardJS/DashboardCollabRH";
import DemandeConges from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/DemandeConges";
import BulletinsPaie from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/BulletinsPaie";
import FeuillesTemps from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/FeuillesTemps";
import ExpenseManagement from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/ExpenseManagement";
import MesAvances from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/MesAvances";
import MesOrdres from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/MesOrdres";
import MesAttestations from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/MesAttestations";
import MesAvantages from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/MesAvantages";
import SoldeCongesManagement from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/SoldeCongesManagement";
import GestionSalaires from "../app/modules/adminrh/Mesrequetes/MesrequetesJS/GestionSalaires";
import ExportArretePaie from "../app/modules/adminrh/Traitement/TraitementJS/ExportArretePaie";
import ImportFichePaie from "../app/modules/adminrh/parametres/parametresJS/ImportFichePaie";

export const AdminGrhRoutes = [
    // ===== DONNEES =====
    { path: "/trombinoscope", element: <Trombinoscope /> },
    { path: "/organigramme", element: <Organigramme /> },

    // ===== PARAMETRES =====
    { path: "/parametres/workflows", element: <WorkflowManagement /> },
    { path: "/parametres/attestations", element: <ParametrageAttestations /> },
    { path: "/parametres/jours-travail", element: <ParamJT /> },
    { path: "/parametres/note-de-frais", element: <ParamNF /> },
    { path: "/parametres/avance-prets", element: <ParamAvances /> },
    { path: "/parametres/ordre-de-mission", element: <ParamMissions /> },
    { path: "/parametres/conges-absence", element: <ParamConges /> },
    { path: "/parametres/avantages-sociaux", element: <ParamAvantagesSociaux /> },
    { path: "/parametres/offboarding", element: <OffboardingEtapesSettings /> },
    { path: "/soldes-conges", element: <SoldeCongesManagement/> },
    { path: "/salaires", element: <GestionSalaires /> },
    { path: "/import-fiches-de-paie", element: <ImportFichePaie /> },

    // ===== TRAITEMENT =====
    { path: "/traitement/conges-absences", element: <TraitementConges /> },
    { path: "/traitement/doc-rh", element: <TraitementDivers /> },
    { path: "/traitement/note-de-frais", element: <TraitementNotesFrais /> },
    { path: "/traitement/odre-de-mission", element: <TraitementOrdreMission /> },
    { path: "/admin/demande/missions", element: <DemandeMissionAdmin /> },
    { path: "/traitement/avance-prets", element: <TraitementAvances /> },
    { path: "/traitement/avantages-sociaux", element: <TraitementAvantagesSociaux /> },
    { path: "/traitement/feuille-de-temps", element: <TraitementFeuillesTemps /> },

    // ===== OFFBOARDING =====
    { path: "/offboarding", element: <Offboarding /> },

    // ===== DASHBOARD ADMIN =====
    { path: "/dashboard", element: <DashboardAdmin /> },

    // ===== MANAGER =====
    { path: "/manager/dashboard", element: <DashboardManager /> },
    { path: "/manager/historique-demandes", element: <HistoriqueDemandes /> },
    { path: "/manager/agenda", element: <AgendaManager /> },
    { path: "/manager/traitement/conges-absence", element: <TraitementCongesManager /> },
    { path: "/manager/traitement/missions", element: <TraitementOrdreMissionManager /> },
    { path: "/manager/traitement/avance-prets", element: <TraitementAvancesManager /> },
    { path: "/manager/traitement/avantages-sociaux", element: <TraitementAvantagesSociaux manager /> },
    { path: "/manager/traitement/feuille-de-temps", element: <TraitementFeuillesTempsManager /> },
    { path: "/manager/demande/missions", element: <DemandeMissionManager /> },
    { path: "/manager/demande/note-de-frais", element: <TraitementNotesFraisManager /> },
    { path: "/manager/demande/docs-rh", element: <TraitementDiversManager /> },

    // ===== COLLABORATEUR =====
    { path: "/collaborateur/dashboard", element: <DashboardCollabRH /> },
    { path: "/collaborateur/requetes/conges", element: <DemandeConges /> },
    { path: "/collaborateur/requetes/fiches-de-paie", element: <BulletinsPaie /> },
    { path: "/collaborateur/requetes/feuille-de-temps", element: <FeuillesTemps /> },
    { path: "/collaborateur/requetes/notes-de-frais", element: <ExpenseManagement /> },
    { path: "/collaborateur/requetes/avances-prets", element: <MesAvances /> },
    { path: "/collaborateur/requetes/ordres-de-missions", element: <MesOrdres /> },
    { path: "/collaborateur/requetes/attestations", element: <MesAttestations /> },
    { path: "/collaborateur/mes-avantages", element: <MesAvantages /> },
    { path: "/export-arrete", element: <ExportArretePaie /> }
];
